import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import { addOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AttachmentTable from './AttachmentTable';
import ModalPopup from '@ui/components/VnModal';
import AddAttachmentForm from './AddAttachmentForm';
import { useAppDispatch } from '@application/store/useStore';
import { getAllAttachmentsByDocumentationIdAsync } from '@application/features/documentation/documentationThunk';
const AttachmentTab = ({ formData, errors, onFieldChange, isAttachmentTabBold }) => {
    const [isAddAttachmentModalOpen, SetIsAddAttachmentModalOpen] = useState(false);
    const dispatch = useAppDispatch();
    const [documentationDocuments, setDocumentationDocuments] = useState([]);
    function oncloseClicked() {
        SetIsAddAttachmentModalOpen(false);
    }
    const handleButtonClick = () => {
        SetIsAddAttachmentModalOpen(true);
    };
    const { id } = useParams();
    const handleDocumentationDocumentGridUpdate = () => {
        if (id) {
            dispatch(getAllAttachmentsByDocumentationIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setDocumentationDocuments(res);
                if (isAttachmentTabBold && res.length > 0) {
                    isAttachmentTabBold(true);
                }
                else {
                    isAttachmentTabBold && isAttachmentTabBold(false);
                }
            });
        }
    };
    useEffect(() => {
        if (id) {
            dispatch(getAllAttachmentsByDocumentationIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setDocumentationDocuments(res);
                if (isAttachmentTabBold && res.length > 0) {
                    isAttachmentTabBold(true);
                }
                else {
                    isAttachmentTabBold && isAttachmentTabBold(false);
                }
            });
        }
    }, [dispatch, id]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'Vn-supplier-attachments-button', children: _jsx("div", { children: _jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button', icon: addOutline, onClick: handleButtonClick, isDisabled: !id, children: "Toevoegen Bijlagen" }) }) }), _jsx("div", { className: 'mt-3', children: _jsx(AttachmentTable, { documentationDocuments: documentationDocuments, onDocumentationDocumentGridUpdate: handleDocumentationDocumentGridUpdate }) }), _jsx(ModalPopup, { title: 'Upload bestanden', content: _jsx(AddAttachmentForm, { onClose: oncloseClicked, onDocumentationDocumentGridUpdate: handleDocumentationDocumentGridUpdate }), onOpen: isAddAttachmentModalOpen, onClose: () => oncloseClicked(), modalWidth: 'lg' })] }));
};
export default AttachmentTab;
